import { ExternalPageMessages } from '../types';

export const externalJA: ExternalPageMessages = {
    'app.external.title.thankyou': 'BEVIに参加いただきありがとうございます。',
    'app.external.thankyou_static_1_1': '  BEVI（the Beliefs, Events, and Values Inventory）は、著作権により保護されたテストです。BEVI及びBEVIのレポート、質問項目、質問内容また尺度は、Craig N. Shealy, Ph.Dから、書面により明示的に許可されている場合を除き、その全体又は一部を、配布、複製、変更、応用、公開又は出版することはできません。',
    'app.external.thankyou_static_1_2': '  研究また教育のため、この日本語版BEVIを使用する独占的権利/権限は、Craig N. Shealy, Ph.Dから、西谷 元 教授（広島大学）に付与されています。',
    'app.external.thankyou_static_2': '  BEVI本体と同様に、このレポートの構成またデザインも、継続的に改訂・改善されています。BEVIまたレポートについて、ご提案またご意見がございましたら、どうぞinfo@thebevi.comまで直接ご連絡ください。',
    'app.external.thankyou_static_3': '  BEVIについてのより詳しい情報を必要とされる場合は、International Beliefs and Values Institute（IBAVI）のホームページ（www.ibavi.org）またBEVIのホームページ（thebevi.com）をご参照ください。',
}
